import { atomWithStorage } from "jotai/utils";

export const dealerSearchBarContentAtom = atomWithStorage<string>(
  "dealerSearchBarContentAtom",
  "",
  undefined,
  { getOnInit: true }
);
